import {i18n, initReactI18next} from '@nlabs/gothamui';
import {createRoot} from 'react-dom/client';

import {getGothamUiRedirect} from './lib/gothamUiRedirect';
import {manageExternalLinks} from './utils/externalLinks';
import './styles/main.css';

const legacyRedirect = getGothamUiRedirect(window.location);
if(legacyRedirect?.startsWith('https://')) window.location.replace(legacyRedirect);
else if(legacyRedirect) window.history.replaceState(window.history.state, '', legacyRedirect);

const appContainer = document.getElementById('app');

if(!appContainer) {
  throw new Error('Missing #app root container');
}

if(!i18n.isInitialized) {
  await i18n
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false
      },
      lng: 'en',
      resources: {
        en: {
          translation: {}
        }
      }
    });
}

const isArkhamDocsHost = window.location.hostname === 'arkhamjs.nitrogenx.co';
const isGothamDocsHost = window.location.hostname === 'gothamui.nitrogenx.co';
const isLexDocsHost = window.location.hostname === 'lex.nitrogenx.co';
const isMetropolisDocsHost = window.location.hostname === 'metropolisjs.nitrogenx.co';
const isReaktorDocsHost = window.location.hostname === 'reaktor.nitrogenx.co';
const isReaktorDocsExperience = isReaktorDocsHost || window.location.pathname === '/reaktor/docs' || window.location.pathname.startsWith('/reaktor/docs/');
const RootComponent = isArkhamDocsHost
  ? (await import('./views/ArkhamRouter/ArkhamRouter')).ArkhamRouter
  : isGothamDocsHost
    ? (await import('./microsites/gothamui/GothamDocsApp')).GothamDocsApp
    : isLexDocsHost
      ? (await import('./views/Lex/Lex')).Lex
    : isMetropolisDocsHost
        ? (await import('./microsites/metropolisjs/MetropolisDocsApp')).MetropolisDocsApp
        : isReaktorDocsHost
          ? (await import('./microsites/reaktor/ReaktorDocsApp')).ReaktorDocsApp
      : (await import('./components/App')).App;

const {AskNitrogen} = await import('./components/AskNitrogen/AskNitrogen');
manageExternalLinks(appContainer);
if(isReaktorDocsExperience) {
  const {ReaktorAnalyticsProvider} = await import('./components/ReaktorAnalyticsProvider/ReaktorAnalyticsProvider');
  createRoot(appContainer).render(<ReaktorAnalyticsProvider><RootComponent /><AskNitrogen /></ReaktorAnalyticsProvider>);
 } else {
  const {NitrogenMetropolisProvider} = await import('./components/NitrogenMetropolisProvider/NitrogenMetropolisProvider');
  createRoot(appContainer).render(<NitrogenMetropolisProvider><RootComponent /><AskNitrogen /></NitrogenMetropolisProvider>);
}
